<template>
  <div class="main-content-container container-fluid px-4">
    <!-- Page Header -->
    <div class="page-header row no-gutters py-4">
      <div class="col-12 col-sm-12 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle"></span>
        <h3 class="page-title">Template Terima Kasih untuk Donasi</h3>
      </div>
    </div>
    <div class="font_preload" style="opacity: 0">
        <span style="font-family: 'myarimo';"></span>
        <span style="font-family: 'mynimbus';"></span>
        <span style="font-family: 'mypacifico';"></span>
    </div>
    <div class="row">
      <div class="col">
        <div class="card mb-4">
          <div class="card-body p-1 pb-3" style="overflow-x:scroll">
            <br/><br/>
            <d-row style="margin:auto">
            <d-col md="8"  class="form-group" style="text-align:left">
                Warna teks nama donatur
                <color-picker v-model="color"/>
            </d-col>
            <d-col md="4"  class="form-group" style="text-align:left">
                Font teks nama donatur
                <d-form-select v-model="fontfamily" :options="fonts" style="padding-left:1px" />
            </d-col>
            <d-col md="8"  class="form-group" style="text-align:left">
                Warna teks ucapan terima kasih
                <color-picker v-model="colorb"/>
            </d-col>
            <d-col md="4"  class="form-group" style="text-align:left">
                Font teks ucapan terima kasih
                <d-form-select v-model="fontfamilyb" :options="fonts" style="padding-left:1px" />
            </d-col>
            <d-col md="8"  class="form-group" style="text-align:center">
        <div class="editor">
          <canvas id="c" ref="can" width="450vh" height="800vh"></canvas>
        </div>
        <d-button type="button" :disabled="loading" class="btn-accent" @click="save" data-toggle="tooltip" data-placement="top" title="Add New" ><i class="material-icons">note_add</i> Save</d-button>
        <input v-if="!loading" id="uploader" type="file" class="btn" />

            </d-col>
            </d-row>
            <br/><br/>
            <d-row style="margin:auto">
            </d-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import env from '../env.vue';
import { fabric } from 'fabric-browseronly';
import { Photoshop } from 'vue-color';

    export default {
        components:{
          'color-picker' : Photoshop,
        },
        data() {
            return {
                canvas: '',
                loading : false,
                fontfamily : 'arimo',
                color : { hex:'#f00' },
                fontfamilyb : 'arimo',
                colorb : { hex:'#f00' },
                prefill:'/images/receipt/receipt.jpeg',
                fonts : env.fonts,
            }
        },
        watch:{
           color(){
              console.log('color',this.color.hex);
              if( this.canvas.getObjects==undefined ) return
              let objs = this.canvas.getObjects();
              objs.forEach((e)=> {
                if (e && e.type !== 'image') {
                   this.canvas.setActiveObject(e);
                   e.set('fill',this.color.hex);
                   this.canvas.renderAll()
                }
              });
           },
           fontfamily(){
              console.log('fontfamily',this.fontfamily);
              if( this.canvas.getObjects==undefined ) return
              let objs = this.canvas.getObjects();
              objs.forEach((e)=> {
                if (e && e.type !== 'image') {
                   this.canvas.setActiveObject(e);
                   e.set('fontFamily','my'+this.fontfamily);
                   this.canvas.renderAll()
                }
              });
           }
        },
        methods:{
         onChange(){
          if (this.loading) return;
          let dfile = this.$refs.pictureInput.file;
          if (dfile==''||dfile==undefined){
            alert('Harap pilih template');return;
          } 
          this.loading=true;
          let formData = new FormData();
          formData.append('file',dfile);
          console.log(dfile);
          this.axios.post(env.server+'/template/2',
          formData).then( resp=>{
            resp.data=JSON.parse(resp.data);
            console.log(resp.data[0]);
            this.loading=false;
          }).catch( error =>{
            console.log( error );
            this.loading=false;
          });
         },
         save(){
          let objs = this.canvas.getObjects();
          console.log('objs',objs);
          this.loading=true;
          objs.forEach((e)=> {
           if (e && e.type !== 'image') {
              let ddata={ top:e.top, left:e.left, scaleX:e.scaleX, scaleY:e.scaleY, 
                          fill: e.fill, fontFamily:e.fontFamily.replace(/^my/,''),
                          fillb: this.colorb.hex, fontFamilyb:this.fontfamilyb
                        };
              
              this.axios.post(env.server+'/settings/save/2',{ memo: JSON.stringify(ddata) } ).then(
                resp=>{
                  this.loading=false;
                  alert('Save berhasil');
                }
              ).catch( error=>{
                console.log( error );
                this.loading=false;
                alert('Save gagal');
              });
           }
          });
         },
        },
        mounted(){  
          let dleft=0, dtop=0, dscaleX=1, dscaleY=1, dfill=this.color.hex, dfillb=this.colorb.hex, dfontfamily='my'+this.fontfamily, dfontfamilyb=this.fontfamilyb;
          this.axios.get(env.server+'/settings/load/2' ).then(
            resp=>{
              this.loading=false;
              resp = JSON.parse( resp.data);
              resp = JSON.parse( resp.data.memo);
              dleft=resp.left;
              dtop=resp.top;
              dscaleX=resp.scaleX;
              dscaleY=resp.scaleY;
              dfill=resp.fill;
              dfillb=resp.fillb;
              dfontfamily='my'+resp.fontFamily;
              dfontfamilyb='my'+resp.fontFamilyb;
              setTimeout( ()=>{
                  this.fontfamily=resp.fontFamily;
                  this.fontfamilyb=resp.fontFamilyb;
                  this.color={ hex :dfill };
                  this.colorb={ hex: dfillb };
                  console.log( 'color', this.color);
              }, 500);
            }
          ).catch( error=>{
            console.log( error );
            this.loading=false;
          });
          let remove_image=()=> {
              let objs = this.canvas.getObjects();
              objs.forEach((e)=> {
                if (e && e.type === 'image') {
                   this.canvas.setActiveObject(e);
                   this.canvas.remove(e);
                   this.canvas.discardActiveObject().renderAll()
                }
              });
              let active = this.canvas.getActiveObject()
              console.log('delete',active,this.canvas);
          }
          let init=()=>{
              const canvas = new fabric.Canvas('c');
              document.getElementById("uploader").onchange = (e)=> {
                  let reader = new FileReader();
                  reader.onload = (e)=> {
                    let image = new Image();
                    image.src = e.target.result;
                    image.type=e.target.result.split(';')[0];
                    image.onload = function() {
                      if (image.type.match(/jpeg/) === null) {
                        alert('Harap pilih file jpeg');
                        return;
                      }
                    }
                  }
                  let formData = new FormData();
                  formData.append('file',e.target.files[0]);
                  this.axios.post(env.server+'/template/2',
                  formData).then( resp=>{
                    resp.data=JSON.parse(resp.data);
                    //console.log(resp.data[0]);
                    remove_image();
                    setTimeout( ()=>{preload(this.prefill+'?id='+( new Date() ).getTime());},500);
                  }).catch( error =>{
                    console.log( error );
                  });
                  reader.readAsDataURL(e.target.files[0]);
              }
              this.canvas=canvas;
          }
          let load_image= (url,imgElement)=>{
              if (imgElement.width==0) {
                 setTimeout( ()=>{load_image(url,imgElement);},500);
                 return;
              }
              let imgInstance = new fabric.Image(imgElement, {
                left: 0,
                top: 0,
                angle: 0,
                width: imgElement.width,
                opacity: 1,
              });
              setTimeout( ()=>{ 
                imgInstance.scaleToWidth(450);
                imgInstance.set('selectable',false);
                this.canvas.add(imgInstance);
                this.canvas.sendToBack(imgInstance);
              }, 200);
              setTimeout( ()=>{ this.canvas.renderAll(); }, 500);
          }
          let preload=(url)=>{
              let imgElement = new Image();
              imgElement.src=url;
              imgElement.onload = load_image(url, imgElement );
          }
          let render= ()=>{
              if ( !document.fonts.check("30px "+this.fontfamily) ){
                  setTimeout( ()=>{ render(); }, 100 );
                  return;
              }
           let text = new fabric.Text("Nama Donatur", {
              left: dleft, 
              top: dtop, 
              fontSize:30,
              fontFamily:dfontfamily,
              fill:dfill,
              scaleX:dscaleX,
              scaleY:dscaleX,
              selectable: true, 
              hasRotatingPoint: false, 
              lockUniScaling: true, 
            } );
           this.canvas.add(text);
           this.canvas.setActiveObject(text);
           this.canvas.renderAll();
          }
          setTimeout(()=>{init();},100);
          setTimeout(()=>{remove_image();},110);
          setTimeout(()=>{preload(this.prefill+'?id='+( new Date() ).getTime());},200);
          setTimeout(()=>{render();},1000);
        },
    }
</script>
<style>
.editor{
    margin-top:1em;
    display:flex;
    justify-content:center;
}
</style>
